import React from 'react'
import { Form } from 'react-bootstrap'

const sectionOptions = [
  { id: 'fulfillment', label: 'Fulfillment Letters and Postage' },
  { id: 'fulfillment_misc', label: 'Fulfilment Misc' },
  { id: 'fulfillment_tracker', label: 'Refund checks' },
  { id: 'fulfillment_tracker_1', label: 'RK/non-RK tracker' },
  { id: 'supplies', label: 'Supplies' },
  { id: 'storage', label: 'Storage' },
  { id: 'gift_cards', label: 'Gift Cards' },
  { id: 'fedex_expenses', label: 'Shipment Charges' },
];

const FulfilmentRightContent = ({ selectedSections = [], onToggleSection }) => {
  return (
    <div>
        {sectionOptions.map((section) => (
            <div className="right-tab-section d-flex align-items-center gap-3" key={section.id}>
                <Form.Check
                    type="checkbox"
                    checked={selectedSections.includes(section.id)}
                    onChange={() => onToggleSection?.(section.id)}
                />
                <h3 className='d-flex align-items-center gap-2 mb-0'>
                    <img src="/assets/images/invoice-user-icon.svg" alt="" />
                    <span className='font-16 font-weight-bold heading-color'>{section.label}</span>
                </h3>
            </div>
        ))}
    </div>
  )
}

export default FulfilmentRightContent
